import { useState } from 'react';

import agent from '../../../../api/agent';
import { Static } from '../../../../static';
import { Pagamenti } from '../models/payment';

type Props = {
	payment: Pagamenti;
};

const PaymentDetail = (props: Props) => {
	const [showDetails, setShowDetails] = useState(false);
	const detailId = 'payment-detail-panel';

	const toggleDetails = async () => {
		agent.Tracking.track(
			`${Static.toggleDetail} ${Static.fromPaymentComponent}`,
		);

		setShowDetails((prev) => !prev);
	};

	return (
		<>
			<div className='card app-card-with-background ps-5 pe-5 pt-3 pb-3 mb-3 d-block d-sm-none'>
				<button
					type='button'
					className='app-toggle-show app-collapse-button'
					onClick={toggleDetails}
					aria-expanded={showDetails}
					aria-controls={detailId}
				>
					<h2 className='app-card-title mb-0'>PAGAMENTO</h2>
					<i
						className={showDetails ? 'fa fa-angle-up' : 'fa fa-angle-down'}
						style={{ fontSize: '1.5rem' }}
						aria-hidden='true'
					/>
				</button>
			</div>
			<div
				id={detailId}
				className={
					showDetails
						? 'card app-card-with-background p-5 d-block d-sm-none'
						: 'd-none'
				}
			>
				{showDetails && (
					<>
						{props.payment.PagamentiRegolari && (
						<div className='app-info-div'>
							<img
								alt=''
								className='app-info-icon'
								src='/images/veritas/invoice//HappyFaceIcon.svg'
							/>
							<div className='ms-2'>
								<span> {props.payment.PagamentiRegolari.Etichetta} </span>
								<br />
								<span className='app-bold'>
									{props.payment.PagamentiRegolari.Valore}
								</span>
							</div>
						</div>
						)}
						{props.payment.PagamentiNonRegolari && (
							<div className='app-info-div mt-4'>
								<img
									alt=''
									className='app-info-icon'
									src='/images/veritas/invoice//SadFaceIcon.svg'
								/>
								<div className='ms-2'>
									<span> {props.payment.PagamentiNonRegolari.Etichetta} </span>
									<br />
									<span className='app-bold'>
										{props.payment.PagamentiNonRegolari.Valore}
									</span>
									<br />
									{props.payment.PagamentiNonRegolari.DettaglioNP.map(
										(item, index) => (
											<div key={index}>{item.Valore}</div>
										),
									)}
								</div>
							</div>
						)}
						<div className='app-info-div mt-4'>
							<img
								alt=''
								className='app-info-icon'
								src='/images/veritas/invoice//WalletIcon.svg'
							/>
							<div className='ms-2'>
								<span> {props.payment.MetodoPagamento.Etichetta} </span>
								<br />
								<span className='app-bold'>
									{props.payment.MetodoPagamento.Valore}
								</span>
								{props.payment.MetodoPagamento.ValoreRimborso && (
									<div>{props.payment.MetodoPagamento.ValoreRimborso}</div>
								)}
							</div>
						</div>
					</>
				)}
			</div>

			<div className='card app-card-with-background p-5 d-none d-sm-block'>
				<h2 className='app-card-title'>PAGAMENTO</h2>
				{props.payment.PagamentiRegolari && (
					<div className='app-info-div mt-4'>
						<img
							alt=''
							className='app-info-icon'
							src='/images/veritas/invoice//HappyFaceIcon.svg'
						/>
						<div className='ms-2'>
							<span> {props.payment.PagamentiRegolari.Etichetta} </span>
							<br />
							<span className='app-bold'>
								{props.payment.PagamentiRegolari.Valore}
							</span>
						</div>
					</div>
				)}
				{props.payment.PagamentiNonRegolari && (
					<div className='app-info-div mt-4'>
						<img
							alt=''
							className='app-info-icon'
							src='/images/veritas/invoice//SadFaceIcon.svg'
						/>
						<div className='ms-2'>
							<span> {props.payment.PagamentiNonRegolari.Etichetta} </span>
							<br />
							<span className='app-bold'>
								{props.payment.PagamentiNonRegolari.Valore}
							</span>
							<br />
							{props.payment.PagamentiNonRegolari.DettaglioNP.map(
								(item, index) => (
									<div key={index}>{item.Valore}</div>
								),
							)}
						</div>
					</div>
				)}
				<div className='app-info-div mt-4'>
					<img
						alt=''
						className='app-info-icon'
						src='/images/veritas/invoice//WalletIcon.svg'
					/>
					<div className='ms-2'>
						<span> {props.payment.MetodoPagamento.Etichetta} </span>
						<br />
						<span className='app-bold'>
							{props.payment.MetodoPagamento.Valore}
						</span>
						{props.payment.MetodoPagamento.ValoreRimborso && (
							<div>{props.payment.MetodoPagamento.ValoreRimborso}</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default PaymentDetail;
